import { Component, OnInit } from '@angular/core';
import { SisrhService } from '@app/services/sisrh.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import layout from '@assets/json/layout.json';
import { AutenticacaoService } from '@app/services/autenticacao.service';

@Component({
  templateUrl: './vaga-detalhes.page.html'
})
export class VagaDetalhesPage implements OnInit {

  idVaga: string;
  detalhesVaga: Observable<any>;
  cpfCandidato;

  layout = layout.vagaDetalhesPage;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sisrhService: SisrhService,
    private autenticacaoService: AutenticacaoService
  ) { }

  ngOnInit() {

    this.cpfCandidato = this.autenticacaoService.getValorUsuarioAtualCandidato.cpf;
    this.activatedRoute.params.subscribe(x => this.idVaga = x.idVaga);

    this.detalhesVaga = this.sisrhService.detalhesVaga(this.idVaga);

  }

  imprimir() {
    print();
  }

}
